import { Component } from 'react'
export class MMLMountErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { err: false } }
  static getDerivedStateFromError() { return { err: true } }
  componentDidCatch(e) { console.warn('MML render error caught:', e?.message) }
  render() { return this.state.err ? null : this.props.children }
}
